import { defineMessages } from 'react-intl'

export default defineMessages({
  formHeading: {
    id: 'createExpenseReport.form.heading',
    defaultMessage: 'Create new expense report',
  },
  draftBadge: {
    id: 'createExpenseReport.form.draftBadge',
    defaultMessage: 'Draft',
  },
  titleLabel: {
    id: 'createExpenseReport.form.titleLabel',
    defaultMessage: 'Title',
  },
  titleRequired: {
    id: 'createExpenseReport.form.titleRequired',
    defaultMessage: 'Title is required',
  },
  titlePlaceholder: {
    id: 'createExpenseReport.form.titlePlaceholder',
    defaultMessage: 'Expense report title',
  },
  travelTicketLabel: {
    id: 'createExpenseReport.form.travelTicketLabel',
    defaultMessage: 'Travel ticket',
  },
  travelTicketPlaceholder: {
    id: 'createExpenseReport.form.travelTicketPlaceholder',
    defaultMessage: 'Select a travel ticket',
  },
  locationLabel: {
    id: 'createExpenseReport.form.locationLabel',
    defaultMessage: 'Location',
  },
  locationPlaceholder: {
    id: 'createExpenseReport.form.locationPlaceholder',
    defaultMessage: 'Type to search...',
  },
  locationRequired: {
    id: 'createExpenseReport.form.locationRequired',
    defaultMessage: 'Location is required',
  },
  departmentLabel: {
    id: 'createExpenseReport.form.departmentLabel',
    defaultMessage: 'Department',
  },
  departmentPlaceholder: {
    id: 'createExpenseReport.form.departmentPlaceholder',
    defaultMessage: 'Type to search...',
  },
  departmentRequired: {
    id: 'createExpenseReport.form.departmentRequired',
    defaultMessage: 'Department is required',
  },
  purposeLabel: {
    id: 'createExpenseReport.form.purposeLabel',
    defaultMessage: 'Purpose',
  },
  purposePlaceholder: {
    id: 'createExpenseReport.form.purposePlaceholder',
    defaultMessage: 'Describe the purpose of this expense report',
  },
  purposeMaxLength: {
    id: 'createExpenseReport.form.purposeMaxLength',
    defaultMessage: 'Purpose must be 2000 characters or fewer',
  },
  expenseItemsHeading: {
    id: 'createExpenseReport.form.expenseItemsHeading',
    defaultMessage: 'Expense items',
  },
  addExpenseItemButton: {
    id: 'createExpenseReport.form.addExpenseItemButton',
    defaultMessage: 'Add expense item',
  },
  editMenuLabel: {
    id: 'createExpenseReport.form.editMenuLabel',
    defaultMessage: 'Edit',
  },
  duplicateMenuLabel: {
    id: 'createExpenseReport.form.duplicateMenuLabel',
    defaultMessage: 'Duplicate',
  },
  removeMenuLabel: {
    id: 'createExpenseReport.form.removeMenuLabel',
    defaultMessage: 'Remove',
  },
  nextApproverLabel: {
    id: 'createExpenseReport.form.nextApproverLabel',
    defaultMessage: 'Next approver',
  },
  nextApproverPlaceholder: {
    id: 'createExpenseReport.form.nextApproverPlaceholder',
    defaultMessage: 'Select next approver',
  },
  nextApproverRequired: {
    id: 'createExpenseReport.form.nextApproverRequired',
    defaultMessage: 'Next approver is required',
  },
  subtotalLabel: {
    id: 'createExpenseReport.form.subtotalLabel',
    defaultMessage: 'Subtotal',
  },
  taxLabel: {
    id: 'createExpenseReport.form.taxLabel',
    defaultMessage: 'Tax',
  },
  reimbursableLabel: {
    id: 'createExpenseReport.form.reimbursableLabel',
    defaultMessage: 'Reimbursable',
  },
  totalLabel: {
    id: 'createExpenseReport.form.totalLabel',
    defaultMessage: 'Total',
  },
  resolvingApproverLabel: {
    id: 'createExpenseReport.form.resolvingApproverLabel',
    defaultMessage: 'Resolving next approver...',
  },
  itemsMinRequired: {
    id: 'createExpenseReport.form.itemsMinRequired',
    defaultMessage: 'Please add at least one expense item',
  },
  resetButton: {
    id: 'createExpenseReport.form.resetButton',
    defaultMessage: 'Reset form',
  },
  saveDraftButton: {
    id: 'createExpenseReport.form.saveDraftButton',
    defaultMessage: 'Save draft',
  },
  submitButton: {
    id: 'createExpenseReport.form.submitButton',
    defaultMessage: 'Submit',
  },
  emptyItemsTitle: {
    id: 'createExpenseReport.form.emptyItemsTitle',
    defaultMessage: 'Info',
  },
  emptyItemsMessage: {
    id: 'createExpenseReport.form.emptyItemsMessage',
    defaultMessage: 'Please add at least one expense item',
  },
})
